var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6004 9.9999C19.6004 12.546 18.589 14.9878 16.7886 16.7881C14.9883 18.5885 12.5465 19.5999 10.0004 19.5999C7.45431 19.5999 5.01252 18.5885 3.21217 16.7881C1.41182 14.9878 0.400391 12.546 0.400391 9.9999C0.400391 7.45382 1.41182 5.01203 3.21217 3.21168C5.01252 1.41133 7.45431 0.399902 10.0004 0.399902C12.5465 0.399902 14.9883 1.41133 16.7886 3.21168C18.589 5.01203 19.6004 7.45382 19.6004 9.9999ZM11.2004 5.1999C11.2004 5.51816 11.074 5.82339 10.8489 6.04843C10.6239 6.27347 10.3187 6.3999 10.0004 6.3999C9.68213 6.3999 9.37691 6.27347 9.15186 6.04843C8.92682 5.82339 8.80039 5.51816 8.80039 5.1999C8.80039 4.88164 8.92682 4.57642 9.15186 4.35137C9.37691 4.12633 9.68213 3.9999 10.0004 3.9999C10.3187 3.9999 10.6239 4.12633 10.8489 4.35137C11.074 4.57642 11.2004 4.88164 11.2004 5.1999ZM8.80039 8.7999C8.48213 8.7999 8.17691 8.92633 7.95186 9.15137C7.72682 9.37642 7.60039 9.68164 7.60039 9.9999C7.60039 10.3182 7.72682 10.6234 7.95186 10.8484C8.17691 11.0735 8.48213 11.1999 8.80039 11.1999V14.7999C8.80039 15.1182 8.92682 15.4234 9.15186 15.6484C9.37691 15.8735 9.68213 15.9999 10.0004 15.9999H11.2004C11.5187 15.9999 11.8239 15.8735 12.0489 15.6484C12.274 15.4234 12.4004 15.1182 12.4004 14.7999C12.4004 14.4816 12.274 14.1764 12.0489 13.9514C11.8239 13.7263 11.5187 13.5999 11.2004 13.5999V9.9999C11.2004 9.68164 11.074 9.37642 10.8489 9.15137C10.6239 8.92633 10.3187 8.7999 10.0004 8.7999H8.80039Z",
    fill: "#118AB2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.b8d15eb9cc956fcbff9a9c646d5394db.svg";
export { ForwardRef as ReactComponent };